// extracted by mini-css-extract-plugin
module.exports = {"basketBtn":"basketBtn_basketBtn__2TRhF","priceTooltip":"basketBtn_priceTooltip__2cPbx"};